import React, { useEffect, useState, useCallback } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { Link } from 'react-router-dom';
import { useLocations } from '../../../../data/Locations'
import { deleteLocation } from '../../../../data/Locations/deleteLocation';

import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';

export const LocationsList = (() => {
    const LocationsQuery = useLocations()
    const [locations, setLocations] = useState()
    const [map, setMap] = useState(null)

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyD4pfCExrP2jhurv5J544dFFl7UpoPDGVk"
    })


    const queryClient = useQueryClient()

    const { mutate: trashLocation } = useMutation(deleteLocation, {
        onSettled: ((data) => {
            queryClient.invalidateQueries('locations')
            alert("Item successfully deleted")
        }),
        onError: ((error) => {
            alert("There was an error: ", error)
        })
    })

    // Map constants
    const containerStyle = {
        width: '100%',
        height: '400px'
    };
    
    const center = {
        lat: 42.129223,
        lng: -80.085060
    };

    const onLoad = useCallback(function callback(map) {
        const bounds = new window.google.maps.LatLngBounds();
        map.fitBounds(bounds);
        setMap(map)
    }, [])

    const onUnmount = useCallback(function callback(map) {
        setMap(null)
    }, [])

    useEffect(() => {
        setLocations(LocationsQuery.data)
    }, [LocationsQuery])

    if (LocationsQuery.isLoading) return (
        <div style={{marginTop:20, textAlign:'center'}}>
            "Loading Location Data..."
        </div>
    );
    if (LocationsQuery.error) return "An error has occurred loading the locations: " + LocationsQuery.error.message;

    return (
        // <div className='h-screen overflow-hidden'>
        <div className='h-screen'>
            <div className='h-screen overflow-scroll'>
                <div>
                    <p className='text-4xl font-bold'> Location List</p>
                </div>
                {locations?.map(location => {
                    return (
                        <div className='my-8 mx-12 outline-black' key={location.uid}>
                            <div className='flex flex-row justify-between place-items-center place-content-center'>
                                <h3 className="text-4xl leading-10 w-4/5 font-medium text-gray-900 ">
                                    {location.name}
                                </h3>
                                <div>
                                    <Link to={`${location.uid}/edit`} className="relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-dkpurple hover:bg-ltpurple hover:text-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Edit</Link>
                                    <button
                                        type='button'
                                        onClick={e => {
                                            trashLocation(location.uid)

                                        }}
                                        className="relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-dkpurple hover:bg-ltpurple hover:text-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        Delete
                            </button>
                                </div>
                            </div>
                            <div className="border-t border-gray-200">
                                <dl className="divide-y divide-gray-200">
                                    <div className="py-2 sm:py-2 sm:grid sm:grid-cols-3 sm:gap-4">
                                        <dt className="text-sm font-medium text-gray-500">
                                            Location Name
                                    </dt>
                                        <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                            <span className="flex-grow">{location.name}</span>
                                        </dd>
                                    </div>
                                    <div className="py-2 sm:grid sm:py-2 sm:grid-cols-3 sm:gap-4">
                                        <dt className="text-sm font-medium text-gray-500">
                                            Location Address
                                    </dt>
                                        <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                            <span className="flex-grow">
                                                {`${location.street} ${location.city}, ${location.state}  ${location.zip}`}
                                            </span>
                                        </dd>
                                    </div>
                                    <div className="py-2 sm:grid sm:py-2 sm:grid-cols-3 sm:gap-4">
                                        <dt className="text-sm font-medium text-gray-500">
                                            Type
                                    </dt>
                                        <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                            <span className="flex-grow">{location.type}</span>
                                        </dd>
                                    </div>
                                    <div className="py-2 sm:grid sm:py-2 sm:grid-cols-3 sm:gap-4">
                                        <dt className="text-sm font-medium text-gray-500">
                                            Hours
                                    </dt>
                                        <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                            <span className="flex-grow">{location.hours}</span>
                                        </dd>
                                    </div>
                                    <div className="py-2 sm:grid sm:py-2 sm:grid-cols-3 sm:gap-4">
                                        <dt className="text-sm font-medium text-gray-500">
                                            Phone #
                                    </dt>
                                        <dd className="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                            <span className="flex-grow">{location.phone}</span>
                                        </dd>
                                    </div>
                                </dl>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
})
